import { guardClient } from '../_axios'

/**
 * 注力顧客フラグの更新
 * [patch]/company/:companyId/focus-customer
 */
export const updateFocusCustomer = async (
  companyId: number,
  focusCustomer: boolean
): Promise<void> => {
  await guardClient.patch(`/company/${companyId}/focus-customer`, {
    focusCustomer
  })
}
